"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const node_fetch_1 = __importDefault(require("node-fetch"));
const common_1 = require("@affinidi/common");
const did_resolver_1 = require("did-resolver");
const ONE_MINUTE_IN_MS = 60 * 1000;
class AffinidiDidAuthService {
    constructor(affinidiDidAuthServiceOptions) {
        this._encryptedSeed = affinidiDidAuthServiceOptions.encryptedSeed;
        this._encryptionKey = affinidiDidAuthServiceOptions.encryptionKey;
    }
    createDidAuthRequestToken(audienceDid, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwtType = 'DidAuthRequest';
            const NOW = Date.now();
            const jwtObject = yield common_1.JwtService.buildJWTInteractionToken(null, jwtType, null);
            jwtObject.payload.aud = did_resolver_1.parse(audienceDid).did;
            jwtObject.payload.exp = expiresAt > NOW ? expiresAt : NOW + ONE_MINUTE_IN_MS;
            jwtObject.payload.createdAt = NOW;
            const jwtSigned = common_1.Affinidi.signJWTObject(jwtObject, this._encryptedSeed, this._encryptionKey);
            const jwtEncodedAndSigned = common_1.Affinidi.encodeObjectToJWT(jwtSigned);
            return jwtEncodedAndSigned;
        });
    }
    createDidAuthResponseToken(didAuthRequestToken, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwtObject = yield this.buildResponseJwtObject(didAuthRequestToken, expiresAt);
            const jwtSigned = common_1.Affinidi.signJWTObject(jwtObject, this._encryptedSeed, this._encryptionKey);
            const jwtEncodedAndSigned = common_1.Affinidi.encodeObjectToJWT(jwtSigned);
            return jwtEncodedAndSigned;
        });
    }
    buildResponseJwtObject(didAuthRequestToken, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const didAuthRequestTokenDecoded = common_1.JwtService.fromJWT(didAuthRequestToken);
            const jwtType = 'DidAuthResponse';
            const NOW = Date.now();
            const jwtObject = yield common_1.JwtService.buildJWTInteractionToken(null, jwtType, didAuthRequestTokenDecoded);
            jwtObject.payload.requestToken = didAuthRequestToken;
            jwtObject.payload.aud = did_resolver_1.parse(didAuthRequestTokenDecoded.payload.iss).did;
            jwtObject.payload.exp = expiresAt > NOW ? expiresAt : NOW + ONE_MINUTE_IN_MS;
            jwtObject.payload.createdAt = NOW;
            return jwtObject;
        });
    }
    createDidAuthResponseTokenThroughCloudWallet(didAuthRequestToken, apiKey, cloudWalletAccessToken, environment, expiresAt) {
        return __awaiter(this, void 0, void 0, function* () {
            const jwtObject = yield this.buildResponseJwtObject(didAuthRequestToken, expiresAt);
            const cloudWalletSignJwt = `https://cloud-wallet-api.${environment}.affinity-project.org/api/v1/utilities/sign-jwt`;
            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'Api-Key': apiKey,
                Authorization: cloudWalletAccessToken,
            };
            const options = {
                headers,
                method: 'POST',
                body: JSON.stringify({ jwtObject }),
            };
            const response = yield node_fetch_1.default(cloudWalletSignJwt, options);
            const jwtSigned = yield response.json();
            const jwtEncodedAndSigned = common_1.Affinidi.encodeObjectToJWT(jwtSigned.jwtObject);
            return jwtEncodedAndSigned;
        });
    }
    verifyDidAuthResponseToken(didAuthResponseToken, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const affinidiOptions = {
                registryUrl: `https://affinity-registry.${options.environment}.affinity-project.org`,
                apiKey: options.accessApiKey,
            };
            const affinidi = new common_1.Affinidi(affinidiOptions);
            const didAuthResponseTokenDecoded = common_1.JwtService.fromJWT(didAuthResponseToken);
            const didAuthRequestToken = didAuthResponseTokenDecoded.payload.requestToken;
            yield affinidi.validateJWT(didAuthRequestToken);
            yield affinidi.validateJWT(didAuthResponseToken, didAuthRequestToken);
            const didAuthRequestTokenDecoded = common_1.JwtService.fromJWT(didAuthRequestToken);
            const keyService = new common_1.KeysService(this._encryptedSeed, this._encryptionKey);
            const documentService = new common_1.DidDocumentService(keyService);
            const verifierDid = did_resolver_1.parse(documentService.getMyDid()).did;
            const requestIssuerDid = did_resolver_1.parse(didAuthRequestTokenDecoded.payload.iss).did;
            if (requestIssuerDid !== verifierDid) {
                throw new Error('Issuer of request is not valid');
            }
            return true;
        });
    }
    isTokenExpired(token) {
        let isExpired = false;
        let tokenExpiration;
        try {
            const tokenDecoded = common_1.JwtService.fromJWT(token);
            tokenExpiration = tokenDecoded.payload.exp;
        }
        catch (error) {
            throw new Error(`Token can't be decoded`);
        }
        if (!tokenExpiration) {
            throw new Error(`Token doesn't have 'exp' field`);
        }
        tokenExpiration = new Date(tokenExpiration).getTime();
        if (tokenExpiration < Date.now()) {
            isExpired = true;
        }
        return isExpired;
    }
}
exports.default = AffinidiDidAuthService;
//# sourceMappingURL=DidAuthService.js.map